/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Deep_P1Inputs */

const en_csv_to_json_deep_p1 = /** @type {(inputs: Csv_To_Json_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV carries no type information at all. The characters 42 in a cell could be the number forty two, a string, a product code, or a truncated identifier, and nothing in the file says which. This converter therefore emits every value as a JSON string, without exception. It is the one behaviour people most often want changed, and the one most likely to corrupt data if it were changed.`)
};

const ko_csv_to_json_deep_p1 = /** @type {(inputs: Csv_To_Json_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV는 타입 정보를 전혀 담지 않습니다. 칸에 있는 문자 42는 숫자 사십이일 수도, 문자열일 수도, 제품 코드일 수도, 잘린 식별자일 수도 있으며, 파일에는 어느 것인지 알려주는 것이 없습니다. 그래서 이 변환기는 예외 없이 모든 값을 JSON 문자열로 내놓습니다. 사람들이 가장 자주 바꾸고 싶어 하는 동작이자, 바꾸면 데이터를 손상시킬 가능성이 가장 높은 동작입니다.`)
};

const ja_csv_to_json_deep_p1 = /** @type {(inputs: Csv_To_Json_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV は型情報をまったく持ちません。セルの中の文字 42 は数値の 42 かもしれず、文字列かもしれず、製品コードかもしれず、切り詰められた識別子かもしれず、ファイルにはどれなのか示すものがありません。そのためこの変換器は例外なくすべての値を JSON の文字列として出します。人が最も頻繁に変えたがる挙動であり、変えればデータを壊す可能性が最も高い挙動でもあります。`)
};

/**
* | output |
* | --- |
* | "CSV carries no type information at all. The characters 42 in a cell could be the number forty two, a string, a product code, or a truncated identifier, and n..." |
*
* @param {Csv_To_Json_Deep_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_deep_p1 = /** @type {((inputs?: Csv_To_Json_Deep_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Deep_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_deep_p1(inputs)
	if (locale === "ko") return ko_csv_to_json_deep_p1(inputs)
	return ja_csv_to_json_deep_p1(inputs)
});